import styled, { css } from "styled-components";
import { useDrop } from "react-dnd";

export const ScrambleBlankContainer: any = styled.div`
  width: 30px;
  height: 30px;
  border: 1px solid #999;
  margin: 0 1px;
  text-align: center;
  font-family: "Helvetica Neue", sans-serif;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
  font-weight: bold;
  ${(p: any) =>
    p.isOver &&
    css`
      background: #ddd;
    `}
`;

export default ({ char, index, onDrop }: any) => {
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: "LETTER",
      drop: onDrop,
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [onDrop]
  );

  return (
    <div ref={drop}>
      <ScrambleBlankContainer isOver={isOver} />
    </div>
  );
};
